import
  styled
from 'styled-components';
import { ErrorPage } from '../errorPage/ErrorPage';
import { PrimaryButton } from '../input/TextField.styles';
import { ErrorContainer } from '../errorPage/ErrorPage.styles';

export const MainContainer = styled.div`
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  display: ${props => (props.display !== "" ? props.display : "none")};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
`;

export const Container = styled.div`
    display: flex;
    border-radius: 24px;
    width: ${props => (props.isChangePassword ? "48%" : "62%")};
    background-color: #FFF;
    padding: 16px;
    flex-direction: column;

    @media (max-width: 426px) {
        height: ${props => (props.width === "70%" ? "100%" : "")};
        width: ${props => (props.width === "70%" ? "100%" : "")};
        border-radius: ${props => (props.borderRadius !== "" ? "0" : "")};

        ${props => (props.isSuccess)} & {
          width: 100%;
          gap: 10px;
          border-top-left-radius: 24px;
          border-top-right-radius: 24px;
          position: absolute;
          bottom: 0;
        }
    }
    `

export const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;  
  cursor: pointer;
`;

export const BoldUnderlined = styled.span`
color: var(--Greyscale-BLACK, #08081B);

font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 150%;
text-decoration-line: underline;
`;

export const BoldText = styled.span`
    color: var(--Greyscale-BLACK, #08081B);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    font-family: 'RobotoMedium';
`;

export const PopUpContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  // padding: 0 64px 64px;
  padding: 0 0 16px;

  flex-direction: column;
  text-align: center;
  justify-content: center;
  height: -webkit-fill-available;


  @media (max-width: 426px) {
    ${ErrorContainer} & {
    padding: 106px 16px 24px;
  }

  padding: 0 0 16px;
  width: 100%;
  gap: 18px;
}
`;

export const FlexArticle = styled.article`
  display: flex;
`;

export const FlexGrowArticle = styled(FlexArticle)`
padding-bottom: 40px;
@media (max-width: 426px) {
  flex-grow: 1;
}
`;

export const FlexWrapper = styled.section`
    display: flex;
    gap: 24px;
    align-items: center;
    cursor:default;
`;
